module.exports = __webpack_public_path__ + "static/media/gangbot-1.c260558c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Gangbot/gangbot-1.jpg
// module id = 194
// module chunks = 0